module.exports = __webpack_public_path__ + "static/media/Empava_Insight.f9479c73.png";